import React from 'react'
import { Grid, ImagePlaceholder, Typography, makeStyles, useTheme, useMediaQuery } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import type { LabelsOption } from '@paintscout/util/builder'

const FLEX_START_IMPORTANT = 'flex-start !important'

const useStyles = makeStyles<Theme, AboutEstimatorPlaceholderProps>(
  (theme) => ({
    root: {},
    imagePlaceholder: {
      [theme.breakpoints.down('xs')]: {
        alignSelf: 'flex-start '
      }
    },
    imageDiv: {
      justifyContent: FLEX_START_IMPORTANT,
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        alignItems: FLEX_START_IMPORTANT,
        alignContent: FLEX_START_IMPORTANT
      }
    }
  }),
  { name: 'AboutEstimatorPlaceholder' }
)

export interface AboutEstimatorPlaceholderProps {
  classes?: StyleClasses<typeof useStyles>
  objectLabels: LabelsOption
  title?: string
}

function AboutEstimatorPlaceholder(props: AboutEstimatorPlaceholderProps) {
  const classes = useStyles(props)
  const { objectLabels, title } = props
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const responsiveSpacing = isMobile ? 3 : 6

  return (
    <Grid container spacing={responsiveSpacing} alignItems={'center'} classes={{ root: classes.root }}>
      {title && (
        <Grid item xs={12}>
          <Typography variant={'h2'}>{title}</Typography>
        </Grid>
      )}
      <Grid item xs={12} container spacing={3}>
        <Grid item classes={{ root: classes.imageDiv }} xs={12} sm={6}>
          <ImagePlaceholder
            classes={{ root: classes.imagePlaceholder }}
            subtitle={'Estimator Image'}
            width={'100%'}
            height={200}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant={'h3'}>Estimator Name</Typography>
              <Typography variant={'h4'}>Estimator Title</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant={'subtitle1'}
              >{`This section will show information about the ${objectLabels.quote.plural} estimator.`}</Typography>
              <Typography
                variant={'subtitle1'}
              >{`The information displayed can be set in the Estimator's profile.`}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AboutEstimatorPlaceholder
